import { derived } from 'svelte/store';
import { defaultPricingAccess } from '$lib/api/modules-access';
import { modulesAccess } from './modulesAccess';

export const pricingAccess = derived(modulesAccess, ($access) => $access.pricing ?? defaultPricingAccess);
